import React from "react";
import { SurveyItem } from "./SurveyItem";
import { useHistory } from "react-router-dom";

const SurveyBox = ({surveys }) => {
  const survey = surveys[0]
  const history = useHistory();

  return (
    <div className="survey-container">
          <div>Aktuelle Umfragen</div>
          {survey && (
            <SurveyItem
              survey={survey}
              key={survey.id}
              onClick={() => history.push('surveys-list')}
            />
          )}
    </div>
  );
};
  
export default SurveyBox;
  